export default __webpack_public_path__ + "static/pp-logo-35bd0bc55f824a62c4d1089a505a2037.png";